export default "__VITE_ASSET__a8649bf1__"